import "./AddBoostFactorModal.scss"
import { Box } from "@mui/material"
import React, { ReactElement } from "react"
import { formatUnits } from "ethers/lib/utils"
import { formatNumber } from "src/utils/parseStringToBigNumber"
import { XFER } from "src/constants"
import { useAction } from "src/hooks/useAction"
import { actions } from "src/state/xFer"
import useTotalVault from "src/hooks/BoostFarming/useTotalVault"
import { useGetBoostedNfts } from "src/hooks/BoostFarming/useFarmBoostContract"

import cronosCruiserIcon from "../../assets/icons/cronos-cruiser.svg"

import Button from "../Button"
import Text from "../Text"
import DrawerModalWrapper from "../DrawerModalWrapper"
import StepperComponent from "./StepperComponent"
interface Props {
  open: boolean
  onClose: () => void
}
export default function AddBoostFactorModal({
  open,
  onClose,
}: Props): ReactElement {
  const totalVault = useTotalVault()
  const { data: stakedNftData } = useGetBoostedNfts()
  const stakedNftIds = stakedNftData ?? []
  const openDepositModal = useAction(actions.setOpenedDepositModal, {
    defaultSelectedPool: null,
  })
  const openNftStakeModal = useAction(actions.setOpenedNftStakeModal, {
    nftIds: stakedNftIds,
  })
  const handleOpenDepositModal = () => {
    openDepositModal()
    onClose()
  }
  const handleOpenNftModal = () => {
    openNftStakeModal()
    onClose()
  }
  const currentStep = stakedNftIds.length > 0 ? 2 : totalVault.gt(0) ? 1 : 0

  return (
    <DrawerModalWrapper title="Add Boost Factor" open={open} onClose={onClose}>
      <Box mb={3} className="divider" />
      <Text mb={3}>Stake more xFER or NFT to enjoy higher pool APR</Text>
      <StepperComponent activeStep={currentStep} />
      <Box
        display="flex"
        alignItems="stretch"
        mt={1}
        mb={2}
        flexDirection={"row"}
        gap={2}
      >
        <Box className="option-container">
          <Box className="option-header">
            <Box display="flex" my="4px">
              <img height="24px" src={XFER.icon} />
            </Box>
            <Text>Stake xFER to Vault</Text>
          </Box>
          <Box className="option-footer">
            <Text color="dim" size="micro">
              Staked xFER
            </Text>

            <Text mt="4px" mb="16px">
              {totalVault.gt(0)
                ? `${formatNumber(
                    formatUnits(totalVault, XFER.decimals),
                    1,
                    2,
                  )} xFER`
                : "No xFER staked yet"}
            </Text>
            <Button onClick={handleOpenDepositModal} fullWidth>
              Stake{totalVault.gt(0) && " More"}
            </Button>
          </Box>
        </Box>
        <Box className="option-container">
          <Box className="option-header">
            <Box
              my="4px"
              display="flex"
              alignItems="center"
              justifyContent="space-between"
            >
              <img height="24px" src={cronosCruiserIcon} />
              <Text size="small">{"(Optional)"}</Text>
            </Box>
            <Text>Stake Cronos Cruisers NFT </Text>
          </Box>
          <Box className="option-footer">
            <Text color="dim" size="micro">
              Staked NFT
            </Text>
            <Text mt="4px" mb="16px">
              {currentStep === 0
                ? "Stake xFER to unlock"
                : `${stakedNftIds.length} of 10 NFT staked`}
            </Text>
            <Button
              disabled={currentStep === 0}
              onClick={handleOpenNftModal}
              fullWidth
            >
              Stake NFT
            </Button>
          </Box>
        </Box>
      </Box>
    </DrawerModalWrapper>
  )
}
